module.exports = __webpack_public_path__ + "static/media/W19-1340_Smoke_Gouda_Mobile_767x845.97fdbaf4.jpg";